import { PageLayout } from '../../../components/page-layout'
import { AffiliateAbout } from './about/about'
import { PageTitle } from '../../../utils/page-title'

export const Affiliate = () => {
	return (
		<>
			<PageTitle pageName={'Affiliates Program'} />
			<PageLayout
				title="Affiliates Program"
				subtitle="Refer new customers to ClickGuard to earn commission and other benefits"
			>
				<div className="flex justify-between items-center gap-x-6">
					<div className="w-full bg-white p-5 rounded-xl">
						<AffiliateAbout />
					</div>
				</div>
			</PageLayout>
		</>
	)
}
